<template>
    <div>
        <gas-phase-summary-table 
            v-if="this.classification.codeClassification==='gap'"
            v-bind:classification="this.classification"
            v-bind:category="this.category"
            v-bind:datasheets="this.datasheets">
        </gas-phase-summary-table>
        <photolysis-summary-table
            v-if="this.classification.codeClassification==='pho'"
            v-bind:classification="this.classification"
            v-bind:category="this.category"
            v-bind:datasheets="this.datasheets">
        </photolysis-summary-table>
        <heterogeneous-summary-table
            v-if="this.classification.codeClassification==='het'"
            v-bind:classification="this.classification"
            v-bind:category="this.category"
            v-bind:datasheets="this.datasheets">
        </heterogeneous-summary-table>
        <aqueous-phase-summary-table
            v-if="this.classification.codeClassification==='aqp'"
            v-bind:classification="this.classification"
            v-bind:category="this.category"
            v-bind:datasheets="this.datasheets">
        </aqueous-phase-summary-table>
    </div>
</template>

<script>
import GasPhaseSummaryTable from './GasPhaseSummaryTable.vue';
import PhotolysisSummaryTable from './PhotolysisSummaryTable.vue';
import HeterogeneousSummaryTable from './HeterogeneousSummaryTable.vue';
import AqueousPhaseSummaryTable from './AqueousPhaseSummaryTable.vue';

export default {
    name: 'SummaryTables',
    components: { GasPhaseSummaryTable, PhotolysisSummaryTable, HeterogeneousSummaryTable, AqueousPhaseSummaryTable},

    props: ['classification', 'category', 'datasheets']
}
</script>